import axios from "axios";
import env from "../config/env";
import { rememberMasterLabels } from "../i18n/catalog";

let inMemoryAccessToken = "";

export function setInMemoryAccessToken(token) {
  inMemoryAccessToken = String(token || "").trim();
}

export function clearInMemoryAccessToken() {
  inMemoryAccessToken = "";
}

export function getInMemoryAccessToken() {
  return inMemoryAccessToken;
}

const client = axios.create({
  baseURL: env.API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
  timeout: 60000,
});

client.interceptors.request.use(
  (config) => {
    if (inMemoryAccessToken) {
      config.headers.Authorization = `Bearer ${inMemoryAccessToken}`;
    } else if (config.headers?.Authorization) {
      delete config.headers.Authorization;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

client.interceptors.response.use(
  (response) => {
    if (/\/?master\//.test(response.config?.url || "")) rememberMasterLabels(response.data);
    return response;
  },
  (error) => Promise.reject(error)
);

export default client;
